/* eslint-disable no-underscore-dangle */
import axios from "axios";
import Cookies from "js-cookie";
import getAuthToken from "helpers/getAuthToken";
import errorToast from "helpers/errorToast";
import { unsubscribeFromPushManager } from "helpers/notificationHelpers";
import { clearFiltersFromLocalStorage } from "helpers/localStorage";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": "",
  },
  timeout: 60000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalConfig = err.config;
    if (originalConfig?.url !== "/user/token" && err.response) {
      if (err.response.status === 401 && err.response.data.code !== "token_not_valid") {
        try {
          const rs = await axiosInstance.post(`${REACT_APP_CARGOBASE_BASE_URL}/user/token/refresh`, {
            refresh: Cookies.get("cargobase_user_refresh_token"),
          });
          Cookies.set("cargobase_usertoken", rs.data.access, { expires: 7 });
          if (Cookies.get("cargobase_logged_in_as_token")) {
            Cookies.remove("cargobase_logged_in_as_token");
            window.location.reload();
          }
          originalConfig.headers.Authorization = `Bearer ${rs.data.access}`;
          const newInstance = axios.create();
          return await newInstance(originalConfig);
        } catch (_error) {
          unsubscribeFromPushManager();
          localStorage.removeItem("cargobase_userpermissions");
          clearFiltersFromLocalStorage();
          Cookies.remove("cargobase_usertoken");
          Cookies.remove("cargobase_logged_in_as_token");
          Cookies.remove("cargobase_user_refresh_token");
          errorToast(err, "Token expired");
        }
      }
    }
    return Promise.reject(err);
  },
);
export default axiosInstance;
